import { createReducer, on } from "@ngrx/store";
import { seTimelineComponentSetData, seTimelineComponentSetFilters, seTimelineComponentSetPatient, seTimelineComponentSetReport, seTimelineComponentSetReportFilters, seTimelineComponentSetSelectedItem, seTimelineComponentUpdateData, seTimelineComponentUpdateReport } from "./se-timeline.actions";
import { seTimelineInitialState } from "./se-timeline.state";

export const seTimelineReducer = createReducer(
    seTimelineInitialState,

    // Handle SET_PATIENT action
    on(seTimelineComponentSetPatient, (state, { patientId }) => ({
        ...state,
        feature: {
            ...state.feature,
            patientId
        }
    })),

    // Handle SET_SELECTED_ITEM action
    on(seTimelineComponentSetSelectedItem, (state, { selectedItem }) => ({
        ...state,
        feature: {
            ...state.feature,
            selectedItem
        }
    })),

    // Handle SET_DATA action
    on(seTimelineComponentSetData, (state, { data }) => ({
        ...state,
        clinicalHistory: {
            ...state.clinicalHistory,
            data
        }
    })),

    // Handle UPDATE_DATA action (merging new data)
    on(seTimelineComponentUpdateData, (state, { data }) => ({
        ...state,
        clinicalHistory: {
            ...state.clinicalHistory,
            data
        }
    })),

    // Handle SET_FILTERS action
    on(seTimelineComponentSetFilters, (state, { filters }) => ({
        ...state,
        clinicalHistory: {
            ...state.clinicalHistory,
            filters
        }
    })),

    // Handle SET_REPORT action
    on(seTimelineComponentSetReport, (state, { report }) => ({
        ...state,
        reportHistory: {
            ...state.reportHistory,
            report
        }
    })),

    // Handle UPDATE_REPORT action (merging new data)
    on(seTimelineComponentUpdateReport, (state, { report }) => ({
        ...state,
        reportHistory: {
            ...state.reportHistory,
            report
        }
    })),

    // Handle SET_REPORT_FILTERS action
    on(seTimelineComponentSetReportFilters, (state, { filters }) => ({
        ...state,
        reportHistory: {
            ...state.reportHistory,
            filters
        }
    }))
);
